import { render, staticRenderFns } from "./Dichotomous.vue?vue&type=template&id=25c68f5c&"
import script from "./Dichotomous.vue?vue&type=script&lang=js&"
export * from "./Dichotomous.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports